import Disciplinary_Action_Types from "./Admin/Disciplinary_Action_Types";
import Disciplinary_Measurement from "./Admin/Disciplinary_Measurement";
import Disciplinary_Reason from "./Admin/Disciplinary_Reason";
import Foul_Type from "./Admin/Foul_Type";
import Unlink_Categories from "./Admin/Unlink_Categories";
import Disciplinary_Actions from "./Responsible/Disciplinary_Actions";
import Disciplinary_Case from "./Responsible/Disciplinary_Case";
import Sansiones_status from "./Admin/Sansiones_status";
import DocsSanciones from "./Admin/DocsSanciones";
import Monitor from "./Responsible/Monitor";
import DashboardSanciones from "./powerBI/DashboardSanciones";
import Holidays from "./Admin/Holidays";
import Audiences from "./Audiencias/Audiences";
import Reincidencias from "./Reincidencias/Reincidencias";

const routes = [
  {
    type: "private",
    path: "/motivo-acciones-disciplinarias",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Disciplinary_Reason,
    exact: true,
  },
  {
    type: "private",
    path: "/categorias-desvinculación",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Unlink_Categories,
    exact: true,
  },
  {
    type: "private",
    path: "/medidas-disciplinarias",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Disciplinary_Measurement,
    exact: true,
  },
  {
    type: "private",
    path: "/tipos-acciones-disciplinarias",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Disciplinary_Action_Types,
    exact: true,
  },
  {
    type: "private",
    path: "/tipo-falta",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Foul_Type,
    exact: true,
  },
  {
    type: "private",
    path: "/casos-disciplinarios",
    roles: [
      "Encargado_Sanciones",
      "Responsable_Sanciones",
      "alta_direccion",
      "administrador",
      "jefe",
    ],
    component: Disciplinary_Case,
    exact: true,
  },
  {
    type: "private",
    path: "/reincidencias",
    roles: [
      "Encargado_Sanciones",
      "Responsable_Sanciones",
      "alta_direccion",
      "administrador",
      "jefe",
    ],
    component: Reincidencias,
    exact: true,
  },
  {
    type: "private",
    path: "/programacion-audiencias",
    roles: [
      "Encargado_Sanciones",
      "Responsable_Sanciones",
      "alta_direccion",
      "administrador",
    ],
    component: Audiences,
    exact: true,
  },
  {
    type: "private",
    path: "/acciones-disciplinarias",
    roles: ["Encargado_Sanciones", "administrador", "jefe", "alta_direccion"],
    component: Disciplinary_Actions,
    exact: true,
  },
  {
    type: "private",
    path: "/sansiones-estatus",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Sansiones_status,
    exact: true,
  },
  {
    type: "private",
    path: "/sansiones-formatos",
    roles: ["Responsable_Sanciones", "administrador", "jefe"],
    component: DocsSanciones,
    exact: true,
  },
  {
    type: "private",
    path: "/monitor-bajas",
    roles: ["Encargado_Sanciones", "administrador", "Responsable_Headcount"],
    component: Monitor,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard-Sanciones-PowerBI",
    path: "/Tablero-Sanciones",
    roles: [
      "administrador",
      "alta_direccion",
      "Encargado_Sanciones",
      "Responsable_Sanciones",
    ],
    component: DashboardSanciones,
    exact: true,
  },
  {
    type: "private",
    path: "/Holidays",
    roles: ["Responsable_Sanciones", "administrador"],
    component: Holidays,
    exact: true,
  },
];

export default routes;
